module.exports = __webpack_public_path__ + "static/media/Kabutops_gaussian2.950e0273.png";